// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MeMT","messages":"styles_messages__3YjfQ"};